import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "p-4 overflow-auto flex-fill" }

import {ref, computed} from 'vue';
import OperatorApplicationSideMenu from "~/operatorApplication/vue/layout/OperatorApplicationSideMenu.vue";
import OperatorApplicationSideMenuItem from "~/operatorApplication/vue/layout/OperatorApplicationSideMenuItem.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationInitiateChatForSite
    from "~/operatorApplication/vue/initiateChat/OperatorApplicationInitiateChatForSite.vue";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import {__} from "~/ts/library/Translate";

interface Section {
    id: string,
    descr: string
}


const __default__ = {
    name: "OperatorApplicationInitiateChat"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let selected = ref<string>();

let menu = computed(() => {
    let result: Section[] = OperatorAccountStore.data.value.sites.map(site => {
        return {
            id: site.id,
            descr: site.title
        }
    });

    if (!selected.value || !result.find(item => selected.value == item.id)) {
        selected.value = result.length ? result[0].id : null;
    }
    return result;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OperatorApplicationSideMenu, {
      padding: "",
      width: 250,
      "min-width": 250
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
          return (_openBlock(), _createBlock(OperatorApplicationSideMenuItem, {
            key: item.id,
            onClick: ($event: any) => (_isRef(selected) //@ts-ignore
 ? selected.value = item.id : selected = item.id),
            selected: _unref(selected) === item.id,
            class: "text-nowrap"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.descr), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "selected"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_unref(selected))
          ? (_openBlock(), _createBlock(OperatorApplicationInitiateChatForSite, {
              "site-id": _unref(selected),
              key: _unref(selected)
            }, null, 8, ["site-id"]))
          : _createCommentVNode("", true)
      ], 1024)),
      _createVNode(HelpBlock, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(__)('С помощью этого инструмента вы можете первыми написать клиенту в различных каналах связи (Viber,Whatsapp и других) зная его номер телефона.')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(__)('Доступные каналы могут варьироваться в зависимости от того, что настроено для вашего аккаунта в личном кабинете.')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(__)('За отправку сообщений может взиматься дополнительная плата по вашему тарифу, в зависимости от выбранного канала.')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(__)('В некоторых каналах может отправляться только заранее одобренный в качестве сервисного шаблона текст сообщений.')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})